import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

import { getEnv } from '@shared/config';

export interface HttpClientConfig {
  readonly baseURL: string;
  readonly timeout: number;
}

export function createHttpClient(config: HttpClientConfig): AxiosInstance {
  if (config.baseURL.length === 0) {
    throw new Error('[httpClient] baseURL é obrigatório');
  }
  if (config.timeout < 1000) {
    throw new Error('[httpClient] timeout deve ser ≥ 1000ms');
  }

  return axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  } satisfies AxiosRequestConfig);
}

let cached: AxiosInstance | null = null;

export function getHttpClient(): AxiosInstance {
  if (cached === null) {
    const env = getEnv();
    cached = createHttpClient({
      baseURL: env.VITE_API_BASE_URL,
      timeout: env.VITE_API_TIMEOUT_MS,
    });
  }
  return cached;
}

export function __resetHttpClient(): void {
  cached = null;
}
